import { Environment } from './environment.d'

export const AWSEnvironment: Environment = {
  host: '%api_domain%',
  port: 443,
  protocol: 'https',
  production: true,
  basePath: '/api-portal',
  oauth2RedirectUrl: '%redirect_url%',
  oauth2ClientId: '%client_id%',
  oauth2AuthorizeUrl: '%authorize_url%'
}
